import { createContext, useContext } from "react";

export interface InsightsScope {
  programmeGuid: string;
  intakeYear: string;
}

export const InsightsScopeContext = createContext<InsightsScope | undefined>(
  undefined
);
export const useInsightsScope = () => useContext(InsightsScopeContext);
